<template>
  <div class="snail_fourth_layout">
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-snail' v-show="count < 100">
        <div class="title"></div>
        <div class="loading_bg">

          <div class="loading">
            <div class="loading_line"></div>
          </div>
          <div class="loading_text" />
          <div class="change_text">{{ count }}%</div>
        </div>
      </div>
    </transition>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' @loginSuccess="loginSuccess" :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @reInit="reInit"
      @onOfficial="onOfficial" :newUserInfo="newUserInfo" />
    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')" v-show="count >= 100">

      <div class="index" ref="mobile" id="mobile">
        <div class="border_side" v-if="isExpanded" ref="border_side" :style="boxStyle">

          <div class="snail" @click="opt_item_click({ name: 'offical' })" />
          <div class=" border_side_item" :class="item.className" v-for="item in border_side_items" :key="item.key"
            :style="{ 'background-position': item.item_position }" @click="item_click('border_side_item', item)" />
          <div class="expanded" @click="isExpanded = false" />
        </div>

        <div v-else class="border_side_isExpanded" @click="isExpanded = true" ref="border_side1" :style="boxStyle">
          <div class="snail" @click.stop="opt_item_click({ name: 'offical' })" />
        </div>
        <div class="details" @click="ruleShow = true" :style="boxStyle1" ref="details" />

        <div class="main_01" id="#0" ref="myDiv0">
          <div class="title" />
          <div class="logo" />
          <div class="tag1" id="tag1" ref="tag1" />


        </div>
        <div class="main_02">
          <div class="head_box"></div>
          <div class="content">
            <div class="title_02" id="tag11" ref="tag11" />
            <div class="title_02_mini" />
            <div class="reward_box">
              <div class="reward_item" v-for="item in fourth_reward" :key="item.key"
                :style="{ 'background-position': item.position, 'filter': activity.is_reward_get ? 'grayscale(100%) ' : '' }" />

            </div>
            <div class="text_1" />
            <div :class="activity.is_reward_get ? 'get_btn_success' : 'get_btn'" @click="getReward(1)" />
            <div class="title_02_mini1" id="#1" />
            <div class="reward_box">
              <div class="reward_item1" v-for="item in anniversary_reward" :key="item.key"
                :style="{ 'background-position': item.position, 'filter': activity.is_new_reward_get ? 'grayscale(100%) ' : '' }" />

            </div>
            <div class="text_1" />
            <div :class="activity.is_new_reward_get ? 'get_btn_success' : 'get_btn'" @click="getReward(2)" id="tag2"
              ref="tag2" />


          </div>

        </div>
        <div class="main_03">
          <div class="title_03" id="tag22" ref="tag22" />
          <div class="text" />
          <div class="add_box">
            <div class="add_item add_item_self" />
            <div class="add_item add_item_friend" v-if="activity.team_info[0].nick_name" />

            <div v-else class="add_item" @click="openPopup('shareShow')" />
          </div>
          <div class="sign">
            <span>鹂的账号为：</span>
            <span v-if="!isUserInfo"></span>
            <span v-else>{{ activity.status === 1 ? '隐居蜗爷' : activity.status === 2 ? '活跃蜗爷' : '萌新蜗爷' }} </span>
          </div>
          <div class="task">
            <div class="task_item" v-for="item in task_item" :key="item.key"
              :style="{ 'background-position': item.position }">
              <div class="reward_items">
                <div class="reward_item" v-for="ele in item.reward_items" :key="ele.key"
                  :style="{ 'background-position': ele.position }">
                  <div class="flag" v-if="task_info[item.key - 1][ele.get_key]" />
                  <div class="active_flag" v-if="task_info[item.key - 1][ele.get_key]" />
                </div>
              </div>
            </div>
          </div>
          <div class="text_1" />
          <div :class="rewardSum ? 'get_btn_success' : 'get_btn'" @click="getTeamReward" />
          <div class="text_2" />
          <div class="opt_items" id="tag3" ref="tag3">
            <div class="opt_item" v-for="item in opt_item" :key="item.key"
              :style="{ 'background-position': item.position }" @click="opt_item_click(item)" />

          </div>

          <div class="flag"></div>
          <div class="flag1"></div>

        </div>
        <div class="main_04" id="tag33" ref="tag33">
          <div class="click_items">
            <div :class="'click_item ' + (click_item_active == item.key ? 'active' : '')" v-for="item in click_items"
              :key="item.key" :style="{ 'background-position': item.item_out_position }"
              @click="item_click('click_item_active', item)" />
          </div>
          <div class="click_items_sgin" id="tag4" ref="tag4" />
        </div>
        <div class="main_05">
          <div class="video_content">
            <div class="video_title" id="tag44" ref="tag44" />
            <div class="video_items">
              <div class="player" @click="openPopup('videoShow')" />
            </div>
            <div class="video_items_sgin" id="tag5" ref="tag5" />
          </div>
          <div class="other_content">
            <div class="other_title" id="tag55" ref="tag55" />
            <div class="other_items">
              <div class="other_item" v-for="item in other_items" :key="item.key"
                :style="{ 'background-position': item.position }" @click="opt_item_click(item)" />
            </div>
          </div>
          <div class="bottom" ref="bottom" />
        </div>
      </div>
      <div class="foot-page">
        <Footer :gameName="gameName" />
      </div>
    </div>


    <!-- 分享弹窗 -->
    <div class="share_wrap popup_wrap" @click="closePopup('shareShow')"
      :style="{ 'opacity': shareShow ? '1' : '0', 'z-index': shareShow ? '999' : '-1' }">

      <div class="detail_box">
        <div class="main_bg" />
        <div class="bottom">
          <div class="link_box">
            <div class="text_box">
              <div> 组队链接：</div>
              <div style=" overflow: hidden; white-space: nowrap;text-overflow: ellipsis;"> {{ shareLink }}</div>
            </div>
            <a id="link_btn" href="javascript:;" class="link_btn" @click="onCopy('#link_btn')"
              :data-clipboard-text='"有梗有趣，还有蜗和鹂6月21日四周年来袭！组队链接：" + shareLink'></a>

            <img :src="shareImg" alt="分享图片" />
          </div>

          <div class="code_box">
            <div class="text_box">
              长按保存图片或复制链接分享
              给好友进行组队，一起获取组
              队奖励吧！
            </div>

            <div class="qrcode-box">
              <div id="qrcode" class="qrcode"></div>
            </div>

          </div>
        </div>
      </div>


      <div class="text" />

    </div>

    <div class="share_wrap popup_wrap" @click="closePopup('shareShow')"
      :style="{ 'opacity': shareShow ? '0' : '0', 'z-index': shareShow ? '-1' : '-1' }">
      <!-- <div class="share_wrap popup_wrap" @click="closePopup('shareShow')"
      :style="{ 'opacity': shareShow ? '1' : '1', 'z-index': shareShow ? '999' : '999' }"> -->

      <div class="detail_box1" ref="imageDom">
        <div class="main_bg" />
        <div class="bottom">



          <div class="code_box">
            <div class="qrcode-box">
              <div id="qrcode1" class="qrcode1"></div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 视频列表 -->
    <div class="rule_wrap popup_wrap" v-show="videoShow" @click="closePopup('videoShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <video v-if="videoShow" autoplay="autoplay" controlslist="nodownload" disablepictureinpicture="true"
              controls src="https://download4.qcplay.com/snail_four/video/pv.mp4"></video>
          </div>
        </div>
      </transition>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>

    <!-- 信息列表 -->
    <div class="code_wrap popup_wrap" v-show="ruleShow" @click="closePopup('ruleShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="ruleImg" alt="详情">
          </div>
        </div>
      </transition>
    </div>

    <!-- 公众号列表 -->
    <div class="code_wrap popup_wrap" v-show="codeImgShow" @click="closePopup('codeImgShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="ruleImg" alt="详情">
          </div>
        </div>
      </transition>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from "@/components/Footer";
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, reward, secretFreeLoginApi, teamReward, topicShow } from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
import { Indicator } from 'mint-ui';


// import Header from '@/components/Header';

// import eruda from 'eruda';

export default {
  name: 'order',
  components: {
    Header,
    Login,
    Os,
    swiper,
    swiperSlide,
    Footer
  },
  data() {
    return {
      headerConfig,
      gameName: 'snail',
      is_access_token: '',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      taptapUrl: 'https://tap.cn/tm3lTYBt?channel=rep-rep_nlo5ha7ptsr',
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      shareShow: false,
      border_side_item: 1,
      shareImg: null,
      videoShow: false,
      border_side_items: [
        {
          item_position: '0% 0%',
          key: 1,
          val: 'tag1',
          className: 'border_side_item active'
        },
        {
          item_position: '0% 25%',
          key: 2,
          val: 'tag2',
          className: 'border_side_item'
        },
        {
          item_position: '0% 50%',
          key: 3,
          val: 'tag3',
          className: 'border_side_item'
        },
        {
          item_position: '0% 75%',
          key: 4,
          val: 'tag4',
          className: 'border_side_item'
        },
        {
          item_position: '0% 100%',
          key: 5,
          val: 'tag5',
          className: 'border_side_item'
        },
      ],
      task_info: [
        {
          "id": 1,
          "title": "\u5b8c\u6210\u4efb\u52a1",
          "package_id": [
            573
          ],
          "one_get": false,
          "one_is_get": false,
          "two_get": false,
          "two_is_get": false
        },
        {
          "id": 2,
          "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e00\u5929",
          "package_id": [
            574,
            575
          ],
          "one_get": false,
          "one_is_get": false,
          "two_get": false,
          "two_is_get": false
        },
        {
          "id": 3,
          "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e09\u5929",
          "package_id": [
            576,
            577
          ],
          "one_get": false,
          "one_is_get": false,
          "two_get": false,
          "two_is_get": false
        }
      ],
      fourth_reward: [
        {
          position: '0% 0%',
        },
        {
          position: '50% 0%',
        },
        {
          position: '100% 0%',
        },
      ],
      anniversary_reward: [
        {
          position: '0% 0%',
        },
        {
          position: '25.5% 0%',
        },
        {
          position: '50.5% 0%',
        },
        {
          position: '75.5% 0%',
        },
        {
          position: '101% 0%',
        },
      ],
      task_item: [
        {
          position: '0% 0%',
          key: 1,
          reward_items: [
            {
              position: '0% 0%',
              key: 1,
              get_key: 'one_is_get',
            }
          ]
        },
        {
          position: '0% 50%',
          key: 2,
          reward_items: [
            {
              position: '25% 25%',
              key: 2,
              get_key: 'one_is_get',
            },
            {
              position: '50% 50%',
              key: 3,
              get_key: 'two_is_get',
            },
          ]
        },
        {
          position: '0% 100%',
          key: 3,
          reward_items: [
            {
              position: '74% 75%',
              key: 4,
              get_key: 'one_is_get',
            },
            {
              position: '100% 100%',
              key: 5,
              get_key: 'two_is_get',
            },
          ]
        },

      ],
      opt_item: [
        {
          position: '0% 0%',
          key: '1',
          name: 'qq',
          link: 'http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=a9oh27vT2FIUpzPiQ2wSYkSPAsSu7U5R&authKey=6NVwohjMVw0KmU5MBwnedYkvLrX46UQ5iK7McMIPHqxwcZZdRnMdEOKHvutB9E73&noverify=0&group_code=1121141678'
        },
        {
          position: '50% 0%',
          key: 2,
          name: 'tap',
          link: "https://l.taptap.cn/f3JIvRlt?channel=rep-rep_i4m5q6txrfy_h5url1834"
        },
        {
          position: '100% 0%',
          key: 3,
          name: 'wx',
          link: "https://l.taptap.cn/f3JIvRlt?channel=rep-rep_i4m5q6txrfy_h5url1834"
        },

      ],
      click_item_active: 1,
      click_items: [
        {
          item_position: '0% 0%',
          key: 1,
          item_out_position: '0% 0%'
        },
        {
          item_position: '0% 25%',
          key: 2,
          item_out_position: '0% 20%'
        },
        {
          item_position: '0% 50%',
          key: 3,
          item_out_position: '0% 40%'
        },
        {
          item_position: '0% 75%',
          key: 4,
          item_out_position: '0% 60%'
        },
        {
          item_position: '0% 100%',
          key: 5,
          item_out_position: '0% 80%'
        },
        {
          item_position: '0% 100%',
          key: 6,
          item_out_position: '0% 100%'
        },
      ],
      other_items: [
        {
          position: '0% 0%',
          link: 'https://qcg.ink/IGKXT2',
          key: 2,
          name: 'badge',
          time: {
            year: 2024,
            month: 6,
            day: 20,
            hour: 0
          },
          msg: '活动将于6月20日开启！'
        },
        {
          position: '0% 50%',
          key: 1,
          link: 'https://qcg.ink/kJ2nN4',
          name: 'million',
          time: {
            year: 2024,
            month: 6,
            day: 21,
            hour: 0
          },
          msg: '活动将于6月21日开启！'
        },
        {
          position: '0% 100%',
          key: 3,
          link: 'https://l.taptap.cn/9m8CgILz?channel=rep-rep_pes5cq4xey8_h5url1887',
          name: 'tapLink',
          time: {
            year: 2024,
            month: 6,
            day: 21,
            hour: 0
          },
          msg: '活动将于6月21日开启！'
        },

      ],
      messageImg: '',
      isPC: false,
      selectInfo: {},
      isExpanded: false,
      codeShow: false,
      messageShow: false,
      wxLoadShow: false,
      isUserInfo: false,
      shareLink: '',
      user_info: {},
      observer: null,
      loopInt: null,
      rewardSum: 0,
      activity: {
        is_new_reward_get: false,
        is_reward_get: false,
        url_scheme: "weixin://dl/business/?t=y9lnnuaJi5o",
        "status": 2,
        "is_first": 0,
        "team_id": 0,
        "team_info": [{
          "nick_name": "",
          "pic": ""
        }, {
          "nick_name": "",
          "pic": ""
        },],
        "code": "",
        "task_info": {
          "task_info": [
            {
              "id": 1,
              "title": "\u5b8c\u6210\u4efb\u52a1",
              "package_id": [
                573
              ],
              "one_get": false,
              "one_is_get": false,
              "two_get": false,
              "two_is_get": false
            },
            {
              "id": 2,
              "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e00\u5929",
              "package_id": [
                574,
                575
              ],
              "one_get": false,
              "one_is_get": false,
              "two_get": false,
              "two_is_get": false
            },
            {
              "id": 3,
              "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e09\u5929",
              "package_id": [
                576,
                577
              ],
              "one_get": false,
              "one_is_get": false,
              "two_get": false,
              "two_is_get": false
            }
          ],
          "number": 0
        },
      },
      isRewardStart: false,
      ruleShow: false,
      ruleImg: require('../../../../assets/images/active/snail/fourth/01/rule.png'),
      codeImgShow: false,
      sureImg: require('../../../../assets/images/active/mitu/order/pop/sureText.png'),
      sureShow: false,
      copyShow: false,
      copyImg: require('../../../../assets/images/active/mitu/order/pop/copy.png'),
      inviteSgin: true,
      rewardType: 1,
      count: 40,
      observerKey: true,
      scrollToElementTag: null,
      debouncedA: null,
      newUserInfo: {},
      isSticky: false,
      stickyObj: [
        {
          isSticky: false,
          stickyPoint: 0,
          detailScrollTop: 0,
        },
        {
          isSticky: false,
          stickyPoint: 0,
          detailScrollTop: 0,
        }
      ],
      isWechatApp: false,
      heightScale: 1,
      qrcodeSrc: null
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    this.incrementTo100()
    if (
      this.$route.query.token
    ) {
      this.token = this.$route.query.token;
      this.secretFreeLogin();
    } else {
      this.getUserInfo();
    }

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下
      this.isWechatApp = true
    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }

    // 埋点
    const bl = buriedLogger('snail', '最强蜗牛');
    this.logger = bl;
    this.messageImg = null
    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/snail/fourth/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
    if (this.isPC) {
      this.$router.push(`pc${getRandomString()}`);
    } else {
    }


    this.debouncedA = this.debounce(this.border_item_change, 300); // 创建节流版本的 A 方法

  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, true);
    // let el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({
    //   container: el,
    //   useShadowDom: true
    // });
  },
  computed: {
    boxStyle() {
      return this.stickyObj[1].isSticky ? { 'position': 'fixed', top: `${this.stickyObj[1].stickyPoint}px`, 'transform': `scale(${this.heightScale})` } : { 'transform': `scale(${this.heightScale})` };
    },
    boxStyle1() {
      return this.stickyObj[0].isSticky ? { 'position': 'fixed', top: `${this.stickyObj[0].stickyPoint}px` } : {};
    },
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {

            if (!newValue.account) {
              // TAG: 注销的时候
              this.reInit()
            } else {
              console.log('登录成功')
              this.getUserInfo()
            }
          }
        }

      }
    },
    isExpanded: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$nextTick(() => {
            this.checkVisibility()
          })
        }
      }
    }
  },
  beforeDestroy() {
  },
  methods: {
    countDown(item) {
      function getTimestampForDate(year, month, day, hour) {
        const dateObj = new Date(year, month - 1, day, hour);
        const timestamp = dateObj.getTime();

        return timestamp;
      }
      function getCurrentTimestamp() {
        const dateObj = new Date();
        const timestamp = dateObj.getTime();

        return timestamp;
      }
      // 使用示例
      const year = item.time.year; // 年份
      const month = item.time.month; // 月份
      const day = item.time.day; // 日期
      const hour = item.time.hour; // 小时
      const timestamp = getTimestampForDate(year, month, day, hour)
      const currentTimeStamp = getCurrentTimestamp()
      if (timestamp <= currentTimeStamp) {
        window.location.href = item.link
      } else {
        this.onToast(item.msg)
      }

    },
    checkVisibility() {
      const div = this.$refs.border_side;
      if (div) {
        const rect = div.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        let scale = 1;
        const height = (rect.height * 1.2) + 240

        // 判断是否超出视窗
        if (rect.right > viewportWidth || height > viewportHeight) {
          const widthScale = viewportWidth / rect.width;
          this.heightScale = viewportHeight / height;
          // 缩放div
          div.style.transform = `scale(${this.heightScale})`;
          div.style.transformOrigin = 'top right';
        } else {
        }
      }


    },
    onScroll(e) {
      const that = this

      const header = document.getElementsByClassName('account-info')[0].clientHeight
      if (that.$refs.details) {
        const details = that.$refs.details.getBoundingClientRect().top
        const detailsTop = details - header
        if (detailsTop < 60) {
          if (this.stickyObj[0].isSticky === false) {
            this.stickyObj[0].detailScrollTop = e.target.scrollTop
            this.stickyObj[0].isSticky = true
            this.stickyObj[0].stickyPoint = 80
          }
        }

        if (this.stickyObj[0].isSticky) {
          if (e.target.scrollTop < this.stickyObj[0].detailScrollTop) {
            this.stickyObj[0].isSticky = false
          }
        }
      }

      if (that.$refs.border_side) {
        const border_side = that.$refs.border_side.getBoundingClientRect().top
        const border_sideTop = border_side - header
        if (border_sideTop < 160) {
          if (this.stickyObj[1].isSticky === false) {
            this.stickyObj[1].detailScrollTop = e.target.scrollTop
            this.stickyObj[1].isSticky = true
            this.stickyObj[1].stickyPoint = 240

          }
        }
        if (this.stickyObj[1].isSticky) {
          if (e.target.scrollTop < this.stickyObj[1].detailScrollTop) {
            this.stickyObj[1].isSticky = false
            this.isExpanded = false

          }
        }
      }

      if (that.$refs.border_side1) {
        const border_side1 = that.$refs.border_side1.getBoundingClientRect().top
        const border_sideTop = border_side1 - header
        if (border_sideTop < 140) {
          if (this.stickyObj[1].isSticky === false) {
            this.stickyObj[1].detailScrollTop = e.target.scrollTop
            this.stickyObj[1].isSticky = true
            this.stickyObj[1].stickyPoint = 240
            this.isExpanded = true
          }
        }
        if (this.stickyObj[1].isSticky) {
          if (e.target.scrollTop < this.stickyObj[1].detailScrollTop) {
            this.stickyObj[1].isSticky = false
          }
        }
      }

      if (that.$refs.tag1) {
        const two = that.$refs.tag11.getBoundingClientRect().top
        const three = that.$refs.tag22.getBoundingClientRect().top
        const four = that.$refs.tag33.getBoundingClientRect().top
        const five = that.$refs.tag44.getBoundingClientRect().top
        const six = that.$refs.tag55.getBoundingClientRect().top

        if (-30 < six - header && six - header < 120) {
          return that.debouncedA(5)
        }
        if (-30 < five - header && five - header < 120) {
          return that.debouncedA(4)
        }
        if (-30 < four - header && four - header < 120) {
          return that.debouncedA(3)
        }
        if (-30 < three - header && three - header < 120) {
          return that.debouncedA(2)
        }
        if (-30 < two - header && two - header < 120) {
          return that.debouncedA(1)
        }
      }


    },
    debounce(func, delay) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func(...args);
        }, delay);
      };
    },
    opt_item_click(item) {
      switch (item.name) {
        case 'qq':
          if (this.isWechatApp) {
            return this.wxLoadShow = true
          }
          this.logger.sum('最强蜗牛_四周年_qq');
          window.location.href = item.link
          break;
        case 'wx':
          this.logger.sum('最强蜗牛_四周年_wx');
          window.location.href = this.activity.url_scheme
          break;
        case 'tap':
          this.logger.sum('最强蜗牛_四周年_tap');
          window.location.href = item.link
          break;
        case 'badge':
          this.logger.sum('最强蜗牛_四周年_徽章');
          this.countDown(item)
          break;
        case 'million':
          this.logger.sum('最强蜗牛_四周年_百万');
          this.countDown(item)
          break;
        case 'tapLink':
          this.logger.sum('最强蜗牛_四周年_tapLink');
          this.countDown(item)
          break;
        case 'offical':
          this.logger.sum('最强蜗牛_四周年_官网充值');
          window.location.href = "https://pay.qingcigame.com/pay?gameId=39"
          break;
        default:
          break;

      }
    },
    // 免密登录请求
    secretFreeLogin() {
      let params = {
        token: this.token
      };
      secretFreeLoginApi(params).then(response => {
        if (response.code == 200) {
          localStorage.setItem('access_token', response.data.access_token);
          let newQuery = JSON.parse(JSON.stringify(this.$route.query))
          delete newQuery.token
          // 可以值替换参数，不改变路由
          this.$router.replace({
            query: newQuery,
          })

          this.logger.sum("最强蜗牛_四周年_免密登录成功");
        } else {
          this.logger.sum("最强蜗牛_四周年_免密登录失败");
          this.onToast(response.message);
        }
      }).finally(() => {
        this.getUserInfo();
      }).catch((err) => {
        this.onToast(err)
      })
    },
    incrementTo100() {
      const target = 100;
      const duration = 300; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器   
          that.$nextTick(() => {

            that.checkVisibility()
          })
        }
      }, stepTime);

    },


    border_item_change(index) {
      this.border_side_items.forEach(ele => {
        if (ele.key == index) {
          ele.className = "border_side_item active"
        } else {
          ele.className = "border_side_item"
        }
      })
    },
    scrollToElement(item, target) {
      const element = document.getElementById(target); // 获取目标元素
      element.scrollIntoView({
        behavior: 'smooth' // 使用平滑滚动效果（可选）
      });
    },


    item_click(key, item) {
      this[key] = item.key
      if (key === 'border_side_item') {
        this.scrollToElement(item, item.val)
      }
      this.observerKey = false
    },

    getTeamReward() {
      // const params = { ...this.userInfo, type: this.rewardType }
      this.rewardType = null
      function throttle(func, delay) {
        let timeoutId;

        return function () {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      if (!this.isUserInfo) {
        throttle(this.changeLoginPopup(true), 1000)
        return this.onToast('很抱歉，请先登录');
      }
      this.teamRewardFlag = true
      if (!this.activity.task_info.number) return this.onToast('很抱歉，暂无奖励领取')
      if (!this.userInfo.hasOwnProperty('role_id')) {
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id) {
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id.length) {
        throttle(this.changeOsPopup(true), 1000)
        return
      }
      teamReward().then(res => {
        this.logger.sum('最强蜗牛_四周年_领取组队奖励');
        if (res.code === 200) {
          this.getUserInfo()
          this.teamRewardFlag = null
        } else {
          this.onToast(res.message)
          this.teamRewardFlag = null
        }
      }).finally(() => {
        this.teamRewardFlag = null
      })
    },
    async getReward(type) {
      this.rewardType = type
      this.teamRewardFlag = null

      function throttle(func, delay) {
        let timeoutId;

        return function () {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      if (!this.isUserInfo) {
        throttle(this.changeLoginPopup(true), 1000)
        return this.onToast('很抱歉，请先登录');
      }

      if (type == 1 && this.activity.is_reward_get) {
        return this.onToast('很抱歉，您已领取过了')
      }
      if (type == 2 && this.activity.is_new_reward_get) {
        return this.onToast('很抱歉，您已领取过了')
      }
      if (type == 2) {
        try {
          const response = await topicShow()
          if (response.code !== 200) {
            return this.onToast(response.message)
          }
        } catch (error) {
          throw new Error('There has been a problem with your fetch operation: ' + error);
        }
      }

      if (!this.userInfo.hasOwnProperty('role_id')) {
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id) {
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id.length) {
        throttle(this.changeOsPopup(true), 1000)
        return
      }

      this.reward()
    },
    async reward() {
      const params = { ...this.userInfo, type: this.rewardType }
      if (this.rewardType == 2) {
        try {
          const response = await topicShow()
          if (response.code !== 200) {
            return this.onToast(response.message)
          }
        } catch (error) {
          throw new Error('There has been a problem with your fetch operation: ' + error);
        }
      }

      reward(params).then(res => {
        this.logger.sum('最强蜗牛_四周年_领取奖励，type:' + this.rewardType);
        if (res.code === 200) {
          // this.priceShow = true
          this.getUserInfo()
        } else {
          this.onToast(res.message)
        }
      }).finally(() => {
        this.rewardType = null
      })

    },

    // 复制链接w
    onCopy(my_id) {
      if (!this.userInfo.account) {
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this.logger.sum('最强蜗牛_四周年_复制链接邀请好友');
      const clipboard = new Clipboard(my_id);
      clipboard.on('success', (e) => {
        console.log(clipboard, 'success')
        this.onToast('邀请链接复制成功，快快发送给你的好友吧~');

        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        this.onToast('复制失败');
      });
    },
    initShareData() {
      const that = this
      try {
        const { protocol, host } = window.location;
        // if (this.activity.code) {
        this.shareLink = `${protocol}//${host}/snail/fourth/help/${getRandomString()}?code=` + this.activity.code;
        this.$set(this, 'shareLink', this.shareLink)
        this.isSetShare(this.shareLink);
        // 例如：获取好友助力信息等
        // }
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
      generateQRCode(document.getElementById('qrcode1'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.preventShow = false;
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
          Indicator.close();
        })
        .catch((err) => {
          this.preventShow = false;
          Indicator.close();
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 获取用户信息
    async getUserInfo() {
      const that = this
      const params = {
      }
      await onGetInitDataAPI(params).then(response => {
        if (response.code === 200) {
          that.activity = response.data.activity

          this.rewardSum = response.data.activity.task_info.number
          that.isUserInfo = true
          that.onInitState(response);

          this.initShareData();

          that.task_info = response.data.activity.task_info.task_info
          that.user_info = response.data.user_info;
        } else {
          that.isUserInfo = false
          that.onToast(response.message);
          that.setInitUserInfo();
          that.setInitActiveInfo();
        }
      }).catch(() => {
      }).finally(() => {
        document.onvisibilitychange = null
      })
    },
    onInitState(response) {
      const { code } = response || {}
      if (response.code == 200) {
        console.log('初始化数据成功');
        this.setUserInfo(response.data.user_info);
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        this.changeLoginPopup(true);
      }
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.isUserInfo = false; // 是否获取到用户信息，用于判断是否显示登录弹窗等
      this.shareImg = null
      this.task_info = [
        {
          "id": 1,
          "title": "\u5b8c\u6210\u4efb\u52a1",
          "package_id": [
            573
          ],
          "one_get": false,
          "one_is_get": false,
          "two_get": false,
          "two_is_get": false
        },
        {
          "id": 2,
          "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e00\u5929",
          "package_id": [
            574,
            575
          ],
          "one_get": false,
          "one_is_get": false,
          "two_get": false,
          "two_is_get": false
        },
        {
          "id": 3,
          "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e09\u5929",
          "package_id": [
            576,
            577
          ],
          "one_get": false,
          "one_is_get": false,
          "two_get": false,
          "two_is_get": false
        }
      ],
        this.activity = {
          is_new_reward_get: false,
          is_reward_get: false,
          url_scheme: "weixin://dl/business/?t=y9lnnuaJi5o",
          "status": 2,
          "is_first": 0,
          "team_id": 0,
          "team_info": [{
            "nick_name": "",
            "pic": ""
          }, {
            "nick_name": "",
            "pic": ""
          },],
          "code": "",
          "task_info": {
            "task_info": [
              {
                "id": 1,
                "title": "\u5b8c\u6210\u4efb\u52a1",
                "package_id": [
                  573
                ],
                "one_get": true,
                "one_is_get": true,
                "two_get": true,
                "two_is_get": false
              },
              {
                "id": 2,
                "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e00\u5929",
                "package_id": [
                  574,
                  575
                ],
                "one_get": false,
                "one_is_get": false,
                "two_get": false,
                "two_is_get": false
              },
              {
                "id": 3,
                "title": "\u7d2f\u79ef\u767b\u5f55\u6e38\u620f\u4e09\u5929",
                "package_id": [
                  576,
                  577
                ],
                "one_get": false,
                "one_is_get": false,
                "two_get": false,
                "two_is_get": false
              }
            ],
            "number": 0
          },
        },

        this.changeOsPopup(false)
      this.newUserInfo = {}
      this.$set(this, 'task_info', this.task_info)
      this.setInitUserInfo();
      this.setInitActiveInfo();
      console.log('注销')
    },
    LoginCallBack() {
    },
    // 选择角色后
    selectCallback() {
      // 初始化
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      this.setUserInfo(selectInfo);
      console.log(this.selectInfo, '选择角色信息')
      this.newUserInfo = JSON.parse(JSON.stringify(this.selectInfo))
      if (this.rewardType && this.selectInfo.account) {
        this.reward()
      }
      if (this.teamRewardFlag && this.selectInfo.account) {
        this.getTeamReward()
      }
    },
    loginSuccess() {
      this.getUserInfo()
    },
    reInit() {
      console.log('清除data里面相关数据')
      this.clearActiveInfo(); // 清除data里面相关数据
      this.changeOsPopup(false)
    },
    onOfficial() {
      this.isWechatBrowser = wechatBrowser();
      if (this.isWechatBrowser) { // 在微信app下
        console.log('在微信app下');
        return this.wxLoadShow = true
      }
      this.logger.sum('最强蜗牛_四周年_前往下载');
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },

    // TAG: 其他简易封装的方法
    openPopup(name) {
      const that = this
      if (name === 'videoShow') {
        return this[name] = true;
      }

      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      if (name === 'shareShow') {
        this.logger.sum('最强蜗牛_四周年_分享');
        if (!this.shareImg) {
          this.qrcode(this.shareLink);
          setTimeout(() => {
            that.qrcodeSrc = document.getElementById('qrcode').querySelector('img').src
            console.log(that.qrcodeSrc)
            setTimeout(() => {
              that.$nextTick(() => {
                that.generateShareImage();
              });
            }, 10)
          }, 500)

        }
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/fourth/enter${getRandomString()}`,
        title: '有梗有趣，还有蜗和鹂',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/Hmpg68XTBbVFL9n0HyLdNp48EdiWf8mCBSx2naIz.png',
        desc: '有梗有趣，还有蜗和鹂，6月21日四周年来袭！！'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/fourth/index/index.vue